// Tab-memory only. No message history is persisted to browser storage.
const values = new Map<string,{at:number,value:unknown}>();
const pending = new Map<string,Promise<unknown>>();
let generation=0;
export const loadingCacheGeneration=()=>generation;
export function clearLoadingCache() { generation++; values.clear(); pending.clear(); }
export function readLoadingCache<T>(key:string,maxAge=30000):T|undefined {
 const item=values.get(key);
 if(!item || Date.now()-item.at>maxAge){values.delete(key);return undefined;}
 return structuredClone(item.value) as T;
}
export function writeLoadingCache<T>(key:string,value:T) {
 values.delete(key);values.set(key,{at:Date.now(),value:structuredClone(value)});
 while(values.size>40) values.delete(values.keys().next().value!);
}
export async function cachedReference<T>(key:string,load:()=>Promise<T>):Promise<T> {
 const value=readLoadingCache<T>(key);if(value!==undefined)return value;
 const existing=pending.get(key);if(existing)return structuredClone(await existing) as T;
 const version=generation;
 const request=load().then(result=>{if(version===generation)writeLoadingCache(key,result);return result;});
 pending.set(key,request);
 try{return structuredClone(await request);}finally{if(pending.get(key)===request)pending.delete(key);}
}
